import { render, staticRenderFns } from "./AcoesSuspender.vue?vue&type=template&id=66916263&scoped=true"
import script from "./AcoesSuspender.vue?vue&type=script&lang=js"
export * from "./AcoesSuspender.vue?vue&type=script&lang=js"
import style0 from "./AcoesSuspender.vue?vue&type=style&index=0&id=66916263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66916263",
  null
  
)

export default component.exports